/**
 * The value matches the Deutsche Bahn Ril 100 Betriebsstellenart
 */
export enum Betriebsstellenart {
  Bf = 'Bf',
  Bft = 'Bft',
  Abzw = 'Abzw',
  Uest = 'Üst'
}
